// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type AccessorFunction = (datum: any) => number;
export type Direction = 'horizontal' | 'vertical';
